import AdhocReporting from 'components/global/AdhocReporting';

const BusinessAdhocReporting = () => <AdhocReporting />;

export default BusinessAdhocReporting;
